import Enquerylist from "../../../../components/sections/front/enquiry/Enquerylist";
import Tabs from "../../../../components/elements/Tabs";
import { useTranslation } from "react-i18next";

const Enquiry = () => {
  const { t } = useTranslation();

  const tabItems = [
    {
      label: t("General Enquiry"),
      icon: "fa-regular fa-grid",
      content: <Enquerylist />,
    },
    // {
    //   label: "General Report",
    //   icon: "fa-regular fa-chart-line",
    //   content: <SpamReport />,
    // },
  ];

  return (
    <div className="w-full flex flex-col pb-10 bg-white rounded-md">
      <div className="space-y-4 lg:space-y-8 py-8 px-5">
        {/* Header */}
        <div className="flex justify-between items-center border-b border-gray-300 pb-6">
          <div className="flex flex-col gap-2 w-full">
            <div className="font-bold text-lg xl:text-2xl uppercase tracking-tighter text-deep-purple">
              {t("Enquiry Management")}
            </div>
            <div className="text-sm xl:text-base text-gray-600">
              {t(
                "View and manage all customer enquiries and contact form submissions."
              )}
            </div>
          </div>
        </div>
        <Tabs
          items={tabItems}
          contentClass={"w-full px-0 md:px-5"}
          tabsClass="gap-3 p-2 md:p-5 flex items-center gap-4 rounded-lg border-t border-slate-100"
          tabClass={
            "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
          }
          activeTabClass={"bg-primary border border-primary !text-white"}
        />
      </div>
    </div>
  );
};

export default Enquiry;
